export enum AsyncRequestStatus {
    initial = 'initial',
    pending = 'pending',
    fulfilled = 'fulfilled',
    rejected = 'rejected',
}
  